import { ICONS } from '@Const/common'
import React from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import { WriterModel } from '@Entities/work/writer-model'

interface WriterLabelProps {
    linkedWriter: WriterModel
    isAmendable: boolean
    removeWriter(removingWriter: WriterModel): void
}

const WriterLabel = (props: WriterLabelProps) => {
    const { linkedWriter, isAmendable, removeWriter } = props
    return (
        <div className="item" key={linkedWriter.localId}>
            <p
                className="bold small-2"
                title={`${linkedWriter.firstName ? linkedWriter.firstName : ''} ${
                    linkedWriter.lastName ? linkedWriter.lastName : ''
                }`}
            >
                {linkedWriter.firstName} {linkedWriter.lastName}
            </p>
            {isAmendable && (
                <div className="button" onClick={() => removeWriter(linkedWriter)}>
                    <img src={ICONS.close} alt="remove" />
                </div>
            )}
        </div>
    )
}

export default observer(WriterLabel)
